export enum DataDog {
  service = 'customer-account',
  site = 'us3.datadoghq.com',
  sessionSampleRate = 100,
  sessionReplaySampleRate = 20,
  defaultPrivacyLevel = 'mask-user-input',
  minifiedPathPrefix = 'https://my.embracepetinsurance.com'
}
